const steps = document.querySelectorAll('.tabs-nav li');
const stepsContent = document.querySelectorAll('.tab-content');
const modelTargetSize = 2;

document.querySelectorAll('.js-set-entity').forEach(function (entity) {
    entity.addEventListener('model-loaded', function () {
        entity.setAttribute('scale', '1 1 1');
        entity.object3D.updateWorldMatrix(true, true);

        const model = entity.getObject3D('mesh');
        const modelSize = new THREE.Box3()
            .setFromObject(model)
            .getSize(new THREE.Vector3());
        const largestDimension = Math.max(modelSize.x, modelSize.y, modelSize.z);

        if (!Number.isFinite(largestDimension) || largestDimension <= 0) {
            return;
        }

        const scale = modelTargetSize / largestDimension;
        entity.setAttribute('scale', `${scale} ${scale} ${scale}`);
    });
});

steps.forEach(function (element) {
    element.addEventListener('click', function () {

        const stepId = element.getAttribute('data-id');
        const activeStep = document.getElementById(stepId);

        steps.forEach(function (el) {
            el.classList.remove('active');
        });

        stepsContent.forEach(function (el) {
            el.classList.remove('active');
            el.querySelector('.js-set-modelID').removeAttribute('id');
            el.querySelector('.js-set-hdrID').removeAttribute('id');
            el.querySelector('.js-set-entity').removeAttribute('gltf-model');
            el.querySelector('.js-set-sky').removeAttribute('hdri-environment');
        });

        element.classList.add('active')
        activeStep.classList.add('active');
        activeStep.querySelector('.js-set-modelID').setAttribute('id', 'model');
        activeStep.querySelector('.js-set-hdrID').setAttribute('id', 'hdr');
        activeStep.querySelector('.js-set-entity').setAttribute('gltf-model', '#model');
        activeStep.querySelector('.js-set-sky').setAttribute('hdri-environment', 'src: #hdr; replaceTexture: false; toneMapping: 1; exposure: 2; intensity: 1;');
    });
});

//Simulate click on first tab to init first 3d model
document.addEventListener('DOMContentLoaded', () => {
    const activeStep = document.querySelector('.block_exploded_view .tabs-nav .active');
    activeStep.click();
});
